import React from "react";
import { Slider } from "antd";
import Utils from "@/utils";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import { ReactComponent as VolumeIcon } from "@/assets/icons/volume-lound.svg";
import Draggable from "react-draggable";
import sentGAEvent from "@/ga";
import "@/assets/audioAddMusic.less";

const AudioWorkWaveformItemRender = ({
  waveformWidth,
  isLarge,
  isNotAllowDrag,
  audioAddMusicItem,
  wavesurferRef,
  getCutPercent,
  handleDeleteAudioJoinerItem,
  handleRangeChange,
  handleAllowDrag,
  handleVolumeChange,
  handleDrag,
  dragX,
  limitLeft,
  limitRight,
  coverLeftRef,
  coverRightRef,
  wavesurferContRef,
  rangRef,
}) => {
  return (
    <div className="audio-joiner-item">
      <p className="audio-joiner-item-name" style={{ padding: "0 20px", marginBottom: 20 }}>
        {Utils.omissionString(audioAddMusicItem.name, 6, 6)}
      </p>
      <div className="waveform-cont">
        <div className="rgt-operation">
          <DeleteIcon onClick={() => handleDeleteAudioJoinerItem(audioAddMusicItem.guid)} />
          <div className="volume-operation">
            <VolumeIcon />
            <Slider
              onChange={handleVolumeChange}
              step={0.01}
              min={0}
              max={1}
              tipFormatter={value => (value * 100).toFixed(0) + "%"}
              value={audioAddMusicItem.volume}
              onAfterChange={() => {
                sentGAEvent({
                  category: "add_music_action",
                  action: "add_music_volume_click",
                });
              }}
            />
          </div>
        </div>
        <div style={{ overflow: "hidden", width: "100%", padding: "0 20px" }} ref={wavesurferContRef}>
          <Draggable
            handle={!isLarge && !isNotAllowDrag ? ".waveform-drag" : "null"}
            position={{ x: dragX, y: 0 }}
            bounds={{ left: limitLeft, right: limitRight }}
            axis="x"
            grid={[1, 1]}
            scale={1}
            onDrag={handleDrag}
            cancel=".ant-slider-handle"
            // onStop={handleVideoStop}
          >
            <div className="waveform-drag" style={{ width: `${waveformWidth}%` }}>
              <div className="waveform" ref={wavesurferRef}>
                <div className="range" id="range">
                  <Slider
                    ref={rangRef}
                    step={0.01}
                    range
                    value={[getCutPercent(audioAddMusicItem.start), getCutPercent(audioAddMusicItem.end)]}
                    tooltipVisible={false}
                    tooltipPlacement="bottom"
                    getTooltipPopupContainer={() => document.querySelector("#range")}
                    onChange={handleRangeChange}
                    onAfterChange={() => {
                      handleAllowDrag(false);
                      sentGAEvent({
                        category: "add_music_action",
                        action: "add_music_cut_click",
                      });
                    }}
                    onClick={() => console.log("onClick")}
                    onMouseDown={() => console.log("onMouseDown")}
                    onMouseEnter={() => console.log("hahahhahah")}
                  />
                  <div
                    ref={coverLeftRef}
                    className="cover"
                    style={{
                      left: 0,
                      width: getCutPercent(audioAddMusicItem.start) + "%",
                    }}
                    onClick={() => console.log("sssssssssssss")}
                  ></div>
                  <div
                    ref={coverRightRef}
                    className="cover"
                    style={{
                      left: getCutPercent(audioAddMusicItem.end) + "%",
                      width: 100 - getCutPercent(audioAddMusicItem.end) + "%",
                    }}
                  ></div>
                  <div
                    className="include"
                    style={{
                      left: Math.round(getCutPercent(audioAddMusicItem.start)) + "%",
                      width: Math.round(getCutPercent(audioAddMusicItem.end)) - Math.round(getCutPercent(audioAddMusicItem.start)) + "%",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </Draggable>
        </div>
      </div>
    </div>
  );
};

export default AudioWorkWaveformItemRender;
